<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="my-4">
      <div>
        <h2 class="font-weight-regular pb-4"><span v-html="$t('page-rules.base-rule.section-duration.fields.duration.label')"></span> <span class="red--text">*</span></h2>
        <p v-html="$t('page-rules.base-rule.section-duration.fields.how-far.label')" class="mb-0"></p>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="text-right mb-4">
      <v-form ref="detailsform" v-model="valid">
        <v-select v-model="duration" :items="enquireDurationItems" item-value="key" outlined></v-select>
      </v-form>
      <v-btn v-html="$t('global-terms.save-continue')" @click.stop="save()" color="primary" large :loading="saving" :disabled="saving"></v-btn>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import { ENQUIRE_DURATIONS } from '../../../../../constants'
import { mapActions } from 'pinia'
import { useBookingRuleStore } from '@/stores'
import { clone } from 'ramda'

export default {
  data () {
    return {
      saving: false,
      valid: true,
      mutatableRollingBookingRule: this.clone(this.rollingBookingRule),
    }
  },
  props: {
    place: {
      type: Object,
      required: true,
    },
    isCreate: {
      type: Boolean,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
    },
    rollingBookingRule: {
      type: Object,
      required: true,
    },
    isFinalized: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    enquireDurationItems () {
      let items = []

      for (const key in ENQUIRE_DURATIONS) {
        items.push({
          key,
          text: ENQUIRE_DURATIONS[key],
        })
      }

      return items
    },
    duration: {
      get () {
        return this.mutatableRollingBookingRule.duration.toString()
      },
      set (newValue) {
        this.mutatableRollingBookingRule.duration = parseInt(newValue)
      },
    },
  },
  methods: {
    clone,
    ...mapActions(useBookingRuleStore, ['httpCreateRollingBookingRule', 'httpUpdateRollingBookingRule']),
    save () {
      if (this.$refs.detailsform.validate()) {
        this.saving = true

        const bookingRuleClone = this.clone(this.mutatableRollingBookingRule)
        delete bookingRuleClone.rates
        delete bookingRuleClone.bookingRuleUnits

        if (this.isCreate) {
          const clonePlace = this.clone(this.place)
          // after save, display green notification and emit event to move onto next section
          this.httpCreateRollingBookingRule({ rollingBookingRule: bookingRuleClone, place: clonePlace }).then((ruleId) => {
            this.saving = false
            this.mutatableRollingBookingRule = this.clone(this.rollingBookingRule)

            // forward after saving first form
            this.$router.push({ name: 'place-rules-base-edit', params: { ruleId } })

            if (!this.isFinalized) {
              this.$emit('autoScroll', 1)
              this.$nextTick(() => {
                this.$vuetify.goTo('#second', {
                  duration: 1000,
                  offset: 25,
                })
              })
            }
          })
        } else if (this.isEdit) {
          this.httpUpdateRollingBookingRule({ rollingBookingRule: bookingRuleClone }).then(() => {
            this.saving = false
          })

          if (!this.isFinalized) {
            this.$emit('autoScroll', 1)
            this.$nextTick(() => {
              this.$vuetify.goTo('#second', {
                duration: 1000,
                offset: 25,
              })
            })
          }
        }
      }
    },
  },
  watch: {
    rollingBookingRule (newVal) {
      this.mutatableSeasonalBookingRule = this.clone(newVal)
    },
  },
}
</script>
